import { useId } from "react";
import { twMerge } from "tailwind-merge";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  wrapperClassName?: string;
  label?: string;
  floatingLabel?: boolean;
}

export function Input({
  label,
  wrapperClassName,
  className,
  floatingLabel = true,
  ...inputProps
}: InputProps) {
  const id = useId();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.currentTarget.blur();
    }
    inputProps.onKeyDown?.(e);
  };

  return (
    <div className={twMerge("relative w-full", wrapperClassName)}>
      <input
        type="text"
        id={id}
        className={twMerge(
          "block rounded-lg px-2.5 pb-2.5 pt-5 w-full text-sm bg-gray-50 border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer",
          className
        )}
        placeholder=" "
        {...inputProps}
        onKeyDown={handleKeyDown}
      />
      <label
        htmlFor={inputProps.id || id}
        className={twMerge(
          "absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform origin-[0] left-2.5",
          floatingLabel
            ? "peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-[10px] -translate-y-[10px] scale-75 top-[10px] z-10 peer-focus:text-blue-600 peer-focus:dark:text-blue-500"
            : "top-0 z-10 scale-75"
        )}
      >
        {label}
      </label>
    </div>
  );
}

export default Input;
